// extracted by mini-css-extract-plugin
export var color = "styles-module--color--0f0d1";
export var comingSoon = "styles-module--comingSoon--d2f27";
export var comingSoonContainer = "styles-module--comingSoonContainer--b4119";
export var container = "styles-module--container--6f8c1";
export var content = "styles-module--content--77334";
export var defaultImage = "styles-module--defaultImage--91ad5";
export var desktop = "1340px";
export var giant = "2200px";
export var hoverImage = "styles-module--hoverImage--4e08a";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var price = "styles-module--price--57017";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";
export var title = "styles-module--title--58210";